import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import homeLogo from "../../Assets/IftikharHussainHome.jpg";
import Particle from "../Particle";
import Home2 from "./Home2";
import Type from "./Type";
import { Helmet } from "react-helmet";

function Home() {
  return (
    <>
      <Helmet>
        <title>Iftikhar Hussain | SpidyCoder | Home</title>
        <meta
          name="description"
          content="Self-taught developer creating professional, modern websites and apps with a passion for learning and growth."
        />
        <link rel="canonical" href="https://iftikhariscoding.netlify.app/" />
      </Helmet>
      <section>
        <Container fluid className="home-section" id="home">
          <Particle />
          <Container className="home-content">
            <Row>
              <Col md={7} className="home-header">
                <h1 style={{ paddingBottom: 15 }} className="heading">
                  Hi There!{" "}
                  <span className="wave" role="img" aria-labelledby="wave">
                    👋🏻
                  </span>
                </h1>

                <h1 className="heading-name">
                  I'M
                  <strong className="blue-text"> Iftikhar Hussain</strong>
                </h1>
                <p className="welcome-line">
                  Welcome to my portfolio — where creativity meets code and
                  ideas come to life!
                </p>

                <div style={{ padding: 50, textAlign: "left" }}>
                  <Type />
                </div>
              </Col>

              <Col
                md={5}
                className="d-flex justify-content-center align-items-center"
                style={{ paddingBottom: 20 }}
              >
                <img
                  src={homeLogo}
                  alt="home pic"
                  className="img-fluid rounded-circle border border-dark"
                  style={{ maxHeight: "350px" }}
                />
              </Col>
            </Row>
          </Container>
        </Container>
        <Home2 />
      </section>
    </>
  );
}

export default Home;
